"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArithmeticAbility;
(function (ArithmeticAbility) {
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_NO_BASIC"] = 200000] = "ARITHMETIC_NO_BASIC";
    /** 认识数字，但不会数数 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_NUMBERS_NO_COUNT"] = 200100] = "ARITHMETIC_KNOW_NUMBERS_NO_COUNT";
    /** 会数数，但不会加减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_COUNT_NO_ADD_OR_SUB"] = 200200] = "ARITHMETIC_KNOW_COUNT_NO_ADD_OR_SUB";
    /** 会5以内实物加法，不会5以内实物减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_PHYSICAL_ADD_WITHIN_5_NO_SUB"] = 200300] = "ARITHMETIC_KNOW_PHYSICAL_ADD_WITHIN_5_NO_SUB";
    /** 会5以内实物加减法，不会10以内实物加减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_5_NO_PHYSICAL_ADD_AND_SUB_WITHIN_10"] = 200400] = "ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_5_NO_PHYSICAL_ADD_AND_SUB_WITHIN_10";
    /** 会10以内实物加法，不会10以内实物减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_PHYSICAL_ADD_WITHIN_10"] = 200500] = "ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_PHYSICAL_ADD_WITHIN_10";
    /** 会10以内实物加减法，不会10以内抽象加减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_ABSTRACT_ADD_AND_SUB_WITHIN_10"] = 200600] = "ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_ABSTRACT_ADD_AND_SUB_WITHIN_10";
    /** 会10以内抽象加法，不会10以内抽象减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_ABSTRACT_ADD_WITHIN_10_NO_ABSTRACT_SUB_WITHIN_10"] = 200700] = "ARITHMETIC_KNOW_ABSTRACT_ADD_WITHIN_10_NO_ABSTRACT_SUB_WITHIN_10";
    /** 会10以内抽象加减法，不认识11~20的数 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_NO_11_TO_20"] = 200800] = "ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_NO_11_TO_20";
    /** 会10以内抽象加减法，认识11~20的数，不会20以内加减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_KNOW_11_TO_20_NO_ADD_AND_SUB_WITHIN_20"] = 200900] = "ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_KNOW_11_TO_20_NO_ADD_AND_SUB_WITHIN_20";
    /** 会20以内不进位加法， 不会20以内不退位减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_NOT_CARRY_ADD_WITHIN_20_NO_NOT_BORROW_SUB_WITHIN_20"] = 201000] = "ARITHMETIC_KNOW_NOT_CARRY_ADD_WITHIN_20_NO_NOT_BORROW_SUB_WITHIN_20";
    /** 会20以内不退位加减法，不会进退位加减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_NOT_CARRY_BORROW_ADD_AND_SUB_WITHIN_20_NO_CARRY_BORROW_ADD_AND_SUB"] = 201100] = "ARITHMETIC_KNOW_NOT_CARRY_BORROW_ADD_AND_SUB_WITHIN_20_NO_CARRY_BORROW_ADD_AND_SUB";
    /** 会 20以内进位加法，不会20以内退位减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_CARRY_ADD_WITHIN_20_NO_BORROW_SUB_WITHIN_20"] = 201200] = "ARITHMETIC_KNOW_CARRY_ADD_WITHIN_20_NO_BORROW_SUB_WITHIN_20";
    /** 会20以内进退加减法 */
    ArithmeticAbility[ArithmeticAbility["ARITHMETIC_KNOW_CARRY_BORROW_ADD_AND_SUB_WITHIN_20"] = 201300] = "ARITHMETIC_KNOW_CARRY_BORROW_ADD_AND_SUB_WITHIN_20";
})(ArithmeticAbility = exports.ArithmeticAbility || (exports.ArithmeticAbility = {}));
var LTFormulaType;
(function (LTFormulaType) {
    LTFormulaType[LTFormulaType["ONLYRESULT"] = 0] = "ONLYRESULT";
    LTFormulaType[LTFormulaType["FULLFORMULA"] = 1] = "FULLFORMULA";
})(LTFormulaType = exports.LTFormulaType || (exports.LTFormulaType = {}));
var LTOperation;
(function (LTOperation) {
    LTOperation[LTOperation["ADD"] = 1] = "ADD";
    LTOperation[LTOperation["SUBTRACT"] = 2] = "SUBTRACT";
    LTOperation[LTOperation["ADDORSUB"] = 3] = "ADDORSUB";
})(LTOperation = exports.LTOperation || (exports.LTOperation = {}));
var LTQuestionType;
(function (LTQuestionType) {
    LTQuestionType[LTQuestionType["NORMAL"] = 1] = "NORMAL";
    LTQuestionType[LTQuestionType["QUESTION0"] = 2] = "QUESTION0";
    LTQuestionType[LTQuestionType["QUESTION1"] = 3] = "QUESTION1";
    LTQuestionType[LTQuestionType["QUESTION2"] = 4] = "QUESTION2";
    LTQuestionType[LTQuestionType["QUESTION3"] = 5] = "QUESTION3";
    LTQuestionType[LTQuestionType["QUESTION16"] = 6] = "QUESTION16";
    LTQuestionType[LTQuestionType["QUESTION17"] = 7] = "QUESTION17";
})(LTQuestionType = exports.LTQuestionType || (exports.LTQuestionType = {}));
//# sourceMappingURL=quiz.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/quiz.js
// module id = 1009
// module chunks = 0